import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';

import barReducer from './slices/bar';
import itemsReducer from './slices/item';
import auditReducer from './slices/audit';
import usersReducer from './slices/users';
import unitsReducer from './slices/units';
import chequeReducer from './slices/cheque';
import inventoryReducer from './slices/kitchen';
import employeeReducer from './slices/employees';
import categoriesReducer from './slices/category';
import suppliersReducer from './slices/suppliers';
import barSummaryReducer from './slices/bar-summary';
import permissionsReducer from './slices/permissions';
import monthlySalesReducer from './slices/monthly-sales';
import issuedChequeReducer from './slices/issued-cheque';
import loanAgreementReducer from './slices/loan-agreement';
import packagingItemReducer from './slices/packaging-item';
import stationeryItemReducer from './slices/stationery-item';
import chequeFactoringReducer from './slices/cheque-factoring';
import packagingReturnReducer from './slices/packaging-return';
import reorderSettingsReducer from './slices/reorder-settings';
import purchaseAnalysisReducer from './slices/purchase-analysis';
import advancedPaymentsReducer from './slices/advanced-payments';
import packagingProductReducer from './slices/packaging-product';
import stationeryReturnReducer from './slices/stationery-return';
import inventoryAnalysisReducer from './slices/inventory-analysis';
import barDispatchOrdersReducer from './slices/bar-dispatch-order';
import barPurchaseOrdersReducer from './slices/bar-purchase-order';
import packagingDispatchReducer from './slices/packaging-dispatch';
import stationeryDispatchReducer from './slices/stationery-dispatch';
import packagingItemUsageReducer from './slices/packaging-item-usage';
import packagingStockCountReducer from './slices/packaging-stock-count';
import stationeryStockCountReducer from './slices/stationery-stock-count';
import kitchenPurchaseOrdersReducer from './slices/kitchen-purchase-order';
import kitchenDispatchOrdersReducer from './slices/kitchen-dispatch-order';
import packagingPurchaseOrderReducer from './slices/packaging-purchase-order';
import monthlySalesQuantitiesReducer from './slices/monthly-sales-quantities';
import packagingDamageDispatchReducer from './slices/packaging-damage-dispatch';
import stationeryPurchaseOrderReducer from './slices/stationery-purchase-order';
import stationeryDamageDispatchReducer from './slices/stationery-damage-dispatch';

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const rootReducer = combineReducers({
  users: usersReducer,
  inventory: inventoryReducer,
  permissions: permissionsReducer,
  units: unitsReducer,
  categories: categoriesReducer,
  bar: barReducer,
  suppliers: suppliersReducer,
  employees: employeeReducer,
  kitchenPurchaseOrders: kitchenPurchaseOrdersReducer,
  kitchenDispatchOrders: kitchenDispatchOrdersReducer,
  barDispatchOrders: barDispatchOrdersReducer,
  barPurchaseOrders: barPurchaseOrdersReducer,
  items: itemsReducer,
  barSummary: barSummaryReducer,
  inventoryAnalysis: inventoryAnalysisReducer,
  purchaseAnalysis: purchaseAnalysisReducer,
  monthlySales: monthlySalesReducer,
  monthlySalesQuantities: monthlySalesQuantitiesReducer,
  cheque: chequeReducer,
  chequeFactoring: chequeFactoringReducer,
  issuedCheque: issuedChequeReducer,
  advancedPayments: advancedPaymentsReducer,
  audit: auditReducer,
  packagingProduct: packagingProductReducer,
  packagingItem: packagingItemReducer,
  packagingItemUsage: packagingItemUsageReducer,
  packagingPurchaseOrder: packagingPurchaseOrderReducer,
  packagingDispatch: packagingDispatchReducer,
  packagingReturn: packagingReturnReducer,
  stationeryItem: stationeryItemReducer,
  stationeryPurchaseOrder: stationeryPurchaseOrderReducer,
  stationeryDispatch: stationeryDispatchReducer,
  stationeryReturn: stationeryReturnReducer,
  packagingStockCount: packagingStockCountReducer,
  stationeryStockCount: stationeryStockCountReducer,
  packagingDamageDispatch: packagingDamageDispatchReducer,
  stationeryDamageDispatch: stationeryDamageDispatchReducer,
  reorderSettings: reorderSettingsReducer,
  loanAgreement: loanAgreementReducer,
});

export { rootPersistConfig, rootReducer };
